module.exports = __webpack_public_path__ + "assets/rename.59ed91ea.svg";